export const reduceStr = (str: string, maxNumberSigns: number) => {
    if (typeof str === 'string') {
        if (str.length > maxNumberSigns) {
            return str.slice(0, maxNumberSigns) + '...';
        }
        return str;
    }
    return str;
};
